import logo from './logo.svg';
import clase from './App.modules.css';
import ProductPreview from './ProductPreview/productpreview';
import ProductDetails from './ProductDetails/ProductDetail';
import Topbar from './Topbar/Topbar';
import React, { Component } from 'react';
import ProductData from './Utils/ProductData';

class App extends Component {

  state = {
    productData: ProductData,
    currentPreviewImage: 0,
    currentSelectedFeature: 0
  }

  onColorOptionClick = (pos) => {

    // const updatedPreviewImage = this.state.productData.colorOptions[pos].imageUrl;
    this.setState({ currentPreviewImage: pos });

  }

  onFeatureItemClick = (pos) => {

    this.setState({ currentSelectedFeature: pos })

  }
  //Validar si el estado de los componentes ha sido modificado para actulizar y reenderizar nuevamente.
  //Esto evita ue la pagina se reendirice de manera  innecesaria cada vez que hagamos un clic.
  //Esto es importante hacerlo si notamos que nuestra pagina esta lenta.
  
  // shouldComponentUpdate(nextProps, nextState) {
  //   // console.log('next state =>', nextState);
  //   // console.log('CUrrent state =>', this.state);
    

  //   if(nextState.currentPreviewImage === this.state.currentPreviewImage) { //falta colocar la condicion al precionar los botones de hora y heart
  //     return false;
  //   }
       
  //   return true;
    
  // }

  render() {
    console.log('rendering');
    
    return (
      <div className="App">

        <Topbar />

        <div className='MainContainer'>
          

          <div className='ProductData' >
            <ProductDetails data={this.state.productData} onColorOptionClick={this.onColorOptionClick}
              currentPreviewImage={this.state.currentPreviewImage} onFeatureItemClick={this.onFeatureItemClick}
              currentSelectedFeature={this.state.currentSelectedFeature} />
          </div>

          <div className='ProductPreview'>
            <ProductPreview currentPreviewImage={this.state.productData.colorOptions[this.state.currentPreviewImage].imageUrl}
              currentSelectedFeature={this.state.currentSelectedFeature} />
          </div>

        </div>
      </div>
    );

  }


}

export default App;
